import { initializeDemoData } from "./demoStorage";
import { BASE_URL } from "./apiConfig";

const DEMO_TOKEN_KEY = "demoToken";
const DEMO_MODE_KEY = "demoMode";
const IS_DEMO_MODE_KEY = "isDemoMode";

const parseDemoToken = (token) => {
  if (!token) return null;

  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};

export async function loginDemo(username, password) {
  let response;
  let data;

  try {
    response = await fetch(`${BASE_URL}/api/auth/demo-login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        password,
      }),
    });
  } catch {
    throw new Error("Demo login server is not reachable. Please start the backend.");
  }

  const rawResponse = await response.text();

  try {
    data = rawResponse ? JSON.parse(rawResponse) : {};
  } catch {
    throw new Error("Demo login route is not available. Please restart the backend server.");
  }

  if (!response.ok || !data.token) {
    throw new Error(data.error || "Demo login failed");
  }

  localStorage.setItem(DEMO_TOKEN_KEY, data.token);
  localStorage.setItem(DEMO_MODE_KEY, "true");
  localStorage.setItem(IS_DEMO_MODE_KEY, "true");
  initializeDemoData();
}

export function clearDemoSession() {
  localStorage.removeItem(DEMO_TOKEN_KEY);
  localStorage.removeItem(DEMO_MODE_KEY);
  localStorage.removeItem(IS_DEMO_MODE_KEY);
}

export function clearDemoModeFlag() {
  localStorage.removeItem(DEMO_MODE_KEY);
  localStorage.removeItem(IS_DEMO_MODE_KEY);
}

export function isDemoAuthenticated() {
  const payload = parseDemoToken(localStorage.getItem(DEMO_TOKEN_KEY));
  const valid =
    payload?.mode === "demo" &&
    (!payload.exp || Number(payload.exp) * 1000 > Date.now());

  if (!valid) {
    clearDemoSession();
  }

  return valid;
}

export function isDemoRoute(pathname = window.location.pathname) {
  return pathname === "/demo" || pathname.startsWith("/demo/");
}

export function isDemoMode() {
  const demoFlag =
    localStorage.getItem(DEMO_MODE_KEY) === "true" ||
    localStorage.getItem(IS_DEMO_MODE_KEY) === "true";

  return isDemoAuthenticated() && (isDemoRoute() || demoFlag);
}
